module.exports = __webpack_public_path__ + "assets/img/confirm.03391b0f.svg";